import { baseApiSlice } from '../../commons/base-api.config';
import { HTTP_METHODS } from '../../constants/http';
import {
    API_CREATE_FLOW,
    API_FAVORITE,
    API_PRODUCT_PHOTO,
    API_PRODUCT_PHOTOGRAPHY,
    API_CREATE_IMAGE_POTION,
    API_GET_GENERATED_IMAGES,
    API_GET_GENERATED_TEXTS,
    API_GENERATE_IMAGE,
    API_GET_BACKGROUND_REPLACED_IMAGES,
} from '../../constants/api';
import { IPaginationParams } from '../../interfaces/common.interface';

export const createFlowApiSlice = baseApiSlice.injectEndpoints({
    endpoints(builder) {
        return {
            createTextGeneration: builder.mutation({
                query: (data) => {
                    return {
                        url: API_CREATE_FLOW,
                        method: HTTP_METHODS.POST,
                        body: data,
                    };
                },
                // invalidatesTags: ['generatedResults', 'generatedTexts'],
                transformResponse: (data: { result: any }) => data?.result,
                transformErrorResponse: (response: { status: string | number }) => response.status,
            }),
            createGenerateImage: builder.mutation({
                query: (imageData) => {
                    return {
                        url: API_GENERATE_IMAGE,
                        method: HTTP_METHODS.POST,
                        body: JSON.stringify(imageData),
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    };
                },
                invalidatesTags: ['generatedImages'],
                transformResponse: ({ data }) => {
                    return data;
                },
                transformErrorResponse: (response: { status: string | number }) => response.status,
            }),
            createFavourite: builder.mutation({
                query: (data) => {
                    return {
                        url: API_FAVORITE,
                        method: HTTP_METHODS.POST,
                        body: data,
                    };
                },
                invalidatesTags: ['favourites'],
                transformResponse: (data: { result: any }) => data?.result,
                transformErrorResponse: (response: { status: string | number }) => response.status,
            }),
            getProductPhotographyImages: builder.query<
                Array<{ id: number; inputImage: string }>,
                number
            >({
                query: (brandId) => ({
                    url: `${API_PRODUCT_PHOTO}/?brandId=${brandId}`,
                    method: HTTP_METHODS.GET,
                }),
                providesTags: ['productPhotographyImages'],
                transformResponse: (data: { data: Array<any> }) => data.data,
                transformErrorResponse: (response: { status: string | number }) => response.status,
            }),
            uploadProductPhotographyImages: builder.mutation({
                query: (data) => {
                    const formData = new FormData();
                    formData.append('productPhoto', data.image as File);
                    formData.append('brandId', data.brandId as string);
                    return {
                        url: API_PRODUCT_PHOTO,
                        method: HTTP_METHODS.POST,
                        body: formData,
                    };
                },
                invalidatesTags: ['productPhotographyImages'],
                transformResponse: (data: { result: any }) => data?.result,
                transformErrorResponse: (response: { status: string | number }) => response.status,
            }),
            productPhotography: builder.mutation({
                query: (formData) => {
                    return {
                        url: API_PRODUCT_PHOTOGRAPHY,
                        method: HTTP_METHODS.POST,
                        body: formData,
                    };
                },
                invalidatesTags: ['productPhotographyImages'],
                transformResponse: (data: { result: any }) => data?.result,
                transformErrorResponse: (response: { status: string | number }) => response.status,
            }),
            createImagePotion: builder.mutation({
                query: (formData) => {
                    return {
                        url: API_CREATE_IMAGE_POTION,
                        method: HTTP_METHODS.POST,
                        body: formData,
                    };
                },
                invalidatesTags: ['imagePotion'],
                transformResponse: (data: { result: any }) => data?.result,
                transformErrorResponse: (response: { status: string | number }) => response.status,
            }),
            getGeneratedImages: builder.query<any, IPaginationParams>({
                query(params) {
                    return {
                        url: `${API_GET_GENERATED_IMAGES}?page=${
                            params.page !== undefined ? params.page : 1
                        }&size=7&brandId=${params.brandId}`,
                        method: HTTP_METHODS.GET,
                    };
                },
                providesTags: ['generatedImages'],
                transformResponse: ({ data }: any) => data,
                transformErrorResponse: (response: { status: string | number }) => response.status,
            }),
            getBackGroundReplacedImages: builder.query<any, IPaginationParams>({
                query(params) {
                    return {
                        url: `${API_GET_BACKGROUND_REPLACED_IMAGES}?page=${
                            params.page !== undefined ? params.page : 1
                        }&size=7&brandId=${params.brandId}`,
                        method: HTTP_METHODS.GET,
                    };
                },
                providesTags: ['generatedImages'],
                transformResponse: ({ data }: any) => data,
                transformErrorResponse: (response: { status: string | number }) => response.status,
            }),
            getGeneratedTexts: builder.query<any, IPaginationParams>({
                query: (params) => {
                    return {
                        url: `${API_GET_GENERATED_TEXTS}?page=${
                            params.page !== undefined ? params.page : 1
                        }&size=${params.size}&brandId=${params.brandId}`,
                        method: HTTP_METHODS.GET,
                    };
                },
                providesTags: ['generatedTexts'],
                transformResponse: ({ data }: any) => data,
                transformErrorResponse: (response: { status: string | number }) => response.status,
            }),
        };
    },
});

export const {
    useLazyGetBackGroundReplacedImagesQuery,
    useCreateTextGenerationMutation,
    useCreateGenerateImageMutation,
    useCreateFavouriteMutation,
    useProductPhotographyMutation,
    useGetProductPhotographyImagesQuery,
    useUploadProductPhotographyImagesMutation,
    useCreateImagePotionMutation,
    useLazyGetGeneratedImagesQuery,
    useLazyGetGeneratedTextsQuery,
} = createFlowApiSlice;
